import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { CardListAction } from '../../../../../common/components/cards';
import { ResourceDto, resourceInit } from './resources.dtos';
import ResourcesTable from './table/resourcesTable';
import ResourceDialog from './form/resourceDialog';
import { useDispatch } from 'react-redux';
import { rootSelector } from '../../../../../common/selectors/selectors';
import {
  createResourceActions,
  deleteResourceAction,
  resourcesActions,
  updateResourceActions,
} from './resources.actions';
import { getType } from 'typesafe-actions';
import { ResourceTypesEnum_class } from '../../../../../common/enums/resourceTypes';
import DeleteDialog from '../../../../../common/components/dialog/DeleteDialog';

const ResourcesCards = () => {
  const dispatch = useDispatch();

  const systemResources = rootSelector((state) => state.resources.list);

  const [additionalResources, setAdditionalResources] = useState<ResourceDto[]>(
    []
  );
  const [maps, setMaps] = useState<ResourceDto[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState<ResourceDto>(
    resourceInit
  );

  useEffect(() => {
    dispatch({ type: getType(resourcesActions.request) });
  }, [dispatch]);

  useEffect(() => {
    setAdditionalResources(
      systemResources.filter(
        (d) => d.typeId === ResourceTypesEnum_class.enum.AdditionalResources
      )
    );
    setMaps(
      systemResources.filter(
        (d) => d.typeId === ResourceTypesEnum_class.enum.Maps
      )
    );
  }, [systemResources]);

  const openResoucesDialog = (value: ResourceDto, type: number) => {
    value.typeId = type;
    setSelectedResource(value);
    setDialogOpen(true);
  };

  const handleDialogSave = (resource: ResourceDto) => {
    let allNew = resource.id === '';

    dispatch({
      type: allNew
        ? getType(createResourceActions.request)
        : getType(updateResourceActions.request),
      payload: { ...resource },
    });

    setDialogOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogDelete = async (resource: ResourceDto) => {
    await deleteResourceAction(resource);

    dispatch({ type: getType(resourcesActions.request) });

    setDeleteDialogOpen(false);
    setDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const openDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };

  return (
    <>
      {deleteDialogOpen ? (
        <DeleteDialog
          open={deleteDialogOpen}
          onDelete={handleDialogDelete}
          onClose={handleDeleteDialogClose}
          value={selectedResource}
        />
      ) : null}
      {dialogOpen ? (
        <ResourceDialog
          open={dialogOpen}
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          values={selectedResource}
          openDeleteDialog={openDeleteDialog}
        />
      ) : null}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              item
              xs={12}
              alignItems='center'
              justify='space-between'
            >
              <Typography variant='h6'>
                Additional Resources/Accessibility
              </Typography>
              <CardListAction
                key='Add resources'
                onClick={() => {
                  openResoucesDialog(
                    resourceInit,
                    ResourceTypesEnum_class.enum.AdditionalResources
                  );
                }}
                tooltip='Add resources'
              />
            </Grid>
            <ResourcesTable
              resources={additionalResources}
              editResource={openResoucesDialog}
            />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              item
              xs={12}
              alignItems='center'
              justify='space-between'
            >
              <Typography variant='h6'>Maps</Typography>
              <CardListAction
                key='Add maps'
                onClick={() => {
                  openResoucesDialog(
                    resourceInit,
                    ResourceTypesEnum_class.enum.Maps
                  );
                }}
                tooltip='Add maps'
              />
            </Grid>
            <ResourcesTable
              resources={maps}
              editResource={openResoucesDialog}
            />
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default ResourcesCards;
